import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import UserControlComponent from './user-control.component';

let UserControlModule = angular
  .module('UserControl', [
    uiRouter
  ])
  .component('userControl', UserControlComponent)
  .filter('fileSize', () => {
    return (input) => {
      var asNum = Number.parseFloat(input);
      return !Number.isNaN(asNum) ? asNum : '-';
    };
  })
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('userControl', {
      url: '/user-control',
      data: {
        authRequired: true,
        adminAccountRequired: true,
        paymentExempt: true
      },
      views: {
        'menu': 'adminmenu',
        'content': {
          component: 'userControl'
        },
      },
      resolve: {
        accountsObservable: (AdminService) => {
          return AdminService.retrieveAllAccounts();
        }
      }
    })
  })
  .name;

export default UserControlModule;



// WEBPACK FOOTER //
// ./src/app/pages/user-control/user-control.module.js